export default __webpack_public_path__ + "media/images/corporate/apartments/first_slide_lg-f287355bedf7836a2eee629c568326ee.png";